import React from "react";

import dynamic from "next/dynamic";
import { useBotAuth } from "../../../../helpers/hooks/useBotAuth";
import { DISCORD_TELEGRAM_NAMESPACE } from "../../../../utils/i18nNameSpaces";
import { DISCORD_TG_CONNECT_VIDEO } from "../../../../utils/constants";

const Hero = dynamic(() => import("./sections/Hero"));
const WhatIs = dynamic(() => import("./sections/WhatIs"));
const HowToInstall = dynamic(() => import("./sections/HowToInstall"));
const Benefits = dynamic(() => import("./sections/Benefits"));
const Pricing = dynamic(() => import("./sections/Pricing"));
// const Auth = dynamic(() => import("./sections/Auth"));
const TopGG = dynamic(() => import("./sections/TopGG"));
const FAQ = dynamic(() => import("./sections/FAQ"));
const CTA = dynamic(() => import("./sections/CTA"));

const Index = () => {
  const { authorized, guilds, user } = useBotAuth("telegram");

  return (
    <>
      <Hero namespace={DISCORD_TELEGRAM_NAMESPACE} />
      <WhatIs
        namespace={DISCORD_TELEGRAM_NAMESPACE}
        videoUrl={DISCORD_TG_CONNECT_VIDEO}
      />
      <HowToInstall namespace={DISCORD_TELEGRAM_NAMESPACE} />
      <Benefits namespace={DISCORD_TELEGRAM_NAMESPACE} />
      <Pricing
        guilds={guilds}
        user={user}
        authorized={authorized}
        namespace={DISCORD_TELEGRAM_NAMESPACE}
        botPrice={7}
      />
      {/* <Auth authorized={authorized} namespace={DISCORD_TELEGRAM_NAMESPACE}/> */}
      <TopGG namespace={DISCORD_TELEGRAM_NAMESPACE} />
      <FAQ namespace={DISCORD_TELEGRAM_NAMESPACE} />
      <CTA namespace={DISCORD_TELEGRAM_NAMESPACE} bgColor={"#F4FAF8"} />
    </>
  );
};

export default Index;
